import { useMutation } from '@tanstack/react-query';
import { ApiError } from 'shared/api';

import { patchPassword, postEmailCertification } from './service';

export const usePatchPassword = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: patchPassword,

    onSuccess: () => {
      onSuccess && onSuccess();
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError(error.message);
      }
    },
  });
};

export const usePostEmailCertification = ({
  onError,
  onSuccess,
}: {
  onError: (error: string) => void;
  onSuccess?: () => void;
}) => {
  return useMutation({
    mutationFn: async (email: string) => {
      return postEmailCertification(email);
    },

    onSuccess: () => {
      onSuccess && onSuccess();
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError(error.message);
      }
    },
  });
};
